import { Component, ViewChild, ElementRef, AfterViewInit, Input, OnInit } from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import { IEModal } from '@dfds-ui/experiences/internet-explorer-modal/IEModal';
import { Observable } from 'rxjs/internal/Observable';

@Component({
    selector: "sbw-ie-overlay",
    template: "<div #react></div>",
})
export class IEOverlayComponent implements OnInit {

    @Input() content: Observable<any>

    [x: string]: any;
    constructor() { }

    resources: IEOverlayResources = null

    @ViewChild("react", { static: true }) react: ElementRef;

    ngOnInit() {
        this.content.subscribe(c => {
            this.resources = c

            this.render();
        })
    }

    render() {
        const IEOverlay = ({ }) => {
            return (
                <>
                    { this.resources &&
                        <IEModal
                            heading={this.resources.internetExploreOverlayHeader}
                            description={this.resources.internetExploreOverlayDescription}
                            goToFrontPageText={this.resources.frontPageButtonText}
                            openPageInEdgeText={this.resources.microsoftEdgeButtonText}
                            canClose={false}
                        >
                        </IEModal>
                    }
                </>
            );
        }
        ReactDOM.render(<IEOverlay />, this.react.nativeElement);
    }
}

interface IEOverlayResources {
    frontPageButtonText: string
    internetExploreOverlayDescription: string
    internetExploreOverlayHeader: string
    microsoftEdgeButtonText: string
}
